module.exports = __webpack_public_path__ + "media/images/pc/specials/common/frequent/secret-4d51b0e50bf9796e4d3e7fa2cc5c9960.jpg";